import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PageLoaderComponent } from './components/page-loader';
import { AlertToasterComponent } from './components/alert-toaster';
import { IdleWarningModalComponent } from './components/idle-warning-modal';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, PageLoaderComponent, AlertToasterComponent, IdleWarningModalComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('ai-blling-platform');
}

